import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

function isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
}
/**
 * Validator that requires controls to have a non-empty value including white spaces.
 */
export function RequiredNotBlank(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (isEmptyInputValue(control.value)) {
            return { 'required': true }
        } else {
            return isEmptyInputValue((control.value).trim()) ? { 'required': true } : null;
        }

    }
}
